import { render, staticRenderFns } from "./CopyAllDripsNew2.vue?vue&type=template&id=4de0df86&scoped=true&"
import script from "./CopyAllDripsNew2.vue?vue&type=script&lang=js&"
export * from "./CopyAllDripsNew2.vue?vue&type=script&lang=js&"
import style0 from "./CopyAllDripsNew2.vue?vue&type=style&index=0&id=4de0df86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de0df86",
  null
  
)

export default component.exports